<template>
    <div class="show-pdf">
        <div v-if="src">
            <template >
                <div class="pdf" v-show="fileType === 'pdf'">
                    <div class="header">
                        <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</span>
                        {{currentPage}} / {{pageCount}}
                        <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</span>
                    </div>
                    <div class="section">
                        <pdf
                                class="pdf-section"
                                :src="src"
                                :page="currentPage"
                                @num-pages="pageCount=$event"
                                @page-loaded="currentPage=$event"
                                @loaded="loadPdfHandler">
                        </pdf>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
	import pdf from 'vue-pdf'
	export default {
		components: {
			pdf
		},
	    data() {
	        return {
		        currentPage: 0, // pdf文件页码
		        pageCount: 0, // pdf文件总页数
		        fileType: 'pdf', // 文件类型
		        src: '', // pdf文件地址
	        }
	    },
	    mounted() {
	        this.initSrc()
	    },
		methods: {
		    initSrc() {
			    console.log ()
			    this.src = this.$route.query.src
			    this.$forceUpdate()
		    },
			changePdfPage (val) {
				// console.log(val)
				if (val === 0 && this.currentPage > 1) {
					this.currentPage--
					// console.log(this.currentPage)
				}
				if (val === 1 && this.currentPage < this.pageCount) {
					this.currentPage++
					// console.log(this.currentPage)
				}
			},
			// pdf加载时
			loadPdfHandler (e) {
				this.currentPage = 1 // 加载的时候先加载第一页
			},
		},
		created() {
			// 有时PDF文件地址会出现跨域的情况,这里最好处理一下
			this.src = pdf.createLoadingTask(this.src)
		},
	}
</script>

<style scoped lang="scss">
.show-pdf {
    background: #525659;
    .pdf {
        border: 1px solid transparent;
        .header {
            background: #323639;
            color: white;
            position: fixed;
            top: 0;
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            .turn {
                margin: 0 15px;
                cursor: pointer;
            }
        }
        .section {
            width: 800px;
            height: 1132px;
            margin: 80px auto 50px;
            box-shadow:0 0 5px #000;
            .pdf-section {
                width: 100%;
            }
        }
    }
}
</style>